// https://developers.google.com/tag-manager/devguide
// Event names are coordinated with marketing.
// NOTE: the the GTag event will be ignored if canTriggerGTagEvent() is false.
/**
 * @param {string} eventName
 * @param {!Function} eventCallback
 */
export function triggerGTagEvent(eventName, eventCallback) {
  if (!canTriggerGTagEvent()) {
    eventCallback.call();
    return;
  }

  window['dataLayer'] = window['dataLayer'] || [];
  window['dataLayer'].push({
    'event': eventName,
    'eventCallback': eventCallback,
    // on rare occasions, the Tags may stall and never signal completion, so wait two seconds
    // after which eventCallback is always invoked to ensure the page doesn't stall
    'eventTimeout': 2000,
  });
}

/**
 * NOTE: for the GTM to work, window['google_tag_manager'] && window['ga'] must be present, but
 * this is not necessarily comprehensive.
 * For example, AdBlockers and certain browser configurations may block GTM and/or Google Analytics.
 * https://www.simoahava.com/gtm-tips/use-eventtimeout-eventcallback/
 */
function canTriggerGTagEvent() {
  return window['google_tag_manager'] && window['ga'];
}
